const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CAD: "C$",
  AUD: "A$",
  CHF: "CHF",
  CNY: "¥",
  SEK: "kr",
  NOK: "kr",
  MXN: "$",
  INR: "₹",
  BRL: "R$",
  ZAR: "R",
  TRY: "₺",
};

const CURRENCY_FORMATS: Record<string, { decimal: string; thousand: string }> =
  {
    USD: { decimal: ".", thousand: "," },
    EUR: { decimal: ",", thousand: "." },
    GBP: { decimal: ".", thousand: "," },
    JPY: { decimal: ".", thousand: "," },
    CAD: { decimal: ".", thousand: "," },
    AUD: { decimal: ".", thousand: "," },
    CHF: { decimal: ".", thousand: "'" },
    CNY: { decimal: ".", thousand: "," },
    SEK: { decimal: ",", thousand: " " },
    NOK: { decimal: ",", thousand: " " },
    MXN: { decimal: ".", thousand: "," },
    INR: { decimal: ".", thousand: "," },
    BRL: { decimal: ",", thousand: "." },
    ZAR: { decimal: ".", thousand: "," },
    TRY: { decimal: ",", thousand: "." },
  };

export function formatPrice(
  valueInCents: number | undefined,
  currency: string | undefined,
  ignoreZeroCents = false,
) {
  if (valueInCents === undefined || currency === undefined) {
    return "";
  }
  const value = valueInCents / 100;
  const symbol = CURRENCY_SYMBOLS[currency] || "";
  const format = CURRENCY_FORMATS[currency] || { decimal: ".", thousand: "," };

  const parts = value.toFixed(2).split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, format.thousand);
  return `${symbol}${parts.join(format.decimal)}`.replace(
    /\.00$/,
    ignoreZeroCents ? "" : ".00",
  );
}
